import { createSelector } from 'reselect';
import { MonitoringDashboardState } from '../types/store';

// Возвращает данные прогресса доставок
export const monitoringGetProgressSelector = createSelector(
  (state: { MonitoringDashboard: MonitoringDashboardState }) => state.MonitoringDashboard.progress,
  (progress) => progress ?? {}
);
